import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import {
  type PlaceDetails,
  publicReverseGeocoding as generatedPublicReverseGeocoding,
  type PublicReverseGeocodingParams,
} from '@generated/search-bff';

/**
 * Fetch place details based on the original point provided using the `/api/v2/public/geocode/reverse` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/geocoding/publicReverseGeocoding Search API Documentation}
 */
export async function publicReverseGeocoding(
  params: PublicReverseGeocodingParams,
  apiConfig: ApiConfig,
): Promise<ApiResult<PlaceDetails[]>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'publicReverseGeocoding');
    const data = await generatedPublicReverseGeocoding(params, _apiConfig);

    return {
      status: 'success',
      data,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
